<template>
	<div class="stencilform-lc-wrapper">
		<b-form-group
			:label="letter"
			v-for="letter, index in letters"
			:key="index"
			:class="stencilFontClass"
		>
			<b-form-input type="number" min="0" v-model="l_qty[index]"  @change.native="setQty"  @keyup.native="setQty" :style="showQty"></b-form-input>
		</b-form-group>
	</div>
</template>

<script>
import jQuery from 'jquery'
import { STENCILCONST } from '../modules/constant.js.erb'

export default {
	data() {
		return {
			letters: STENCILCONST._letters,
			l_qty: []
		}
	},
	components: {
		jQuery
	},
	computed: {
		stencilFontClass() {
			return this.$store.state.product.textFontClass
		},
		showQty() {
			//if (this.$store.state.product.activeTab == "3") {
				return { 
					display: "block", 
					fontFamily: "sans-serif" 
				}
			//} else {
			//	return { display: "none" }
			//}
		}
	},

	methods: {
		setQty(evt) {
			this.$store.dispatch('product/SET_ITEMS', this.cleanArray(this.l_qty))
		},
		cleanArray(actual) {
			var newArray = new Array();
			actual.forEach(function(item, index){
				if(parseInt(item) > 0) {
					newArray[index] = item
				}
			})
			return newArray;
		}
	}
}
</script>
